import { render } from "./DomainControl.vue?vue&type=template&id=1dca9b90"
import script from "./DomainControl.vue?vue&type=script&lang=js"
export * from "./DomainControl.vue?vue&type=script&lang=js"

import "./DomainControl.vue?vue&type=style&index=0&id=1dca9b90&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__